import { constants } from "@newsela/angelou";

const { ui } = constants.colors;

export const clickableRowCss = {
  display: "block",
  color: ui.neutral[700],
  textDecoration: "none",
  width: "100%",
  textAlign: "left",
  ":hover, :focus, :focus-within": {
    color: ui.neutral[700],
    backgroundColor: ui.neutral[25],
  },
};
